import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-procesando',
  templateUrl: './dialog-procesando.component.html',
  styleUrls: ['./dialog-procesando.component.css']
})
export class DialogProcesandoComponent implements OnInit {

  Mensaje: string;

  constructor(public dialogRef: MatDialogRef<DialogProcesandoComponent>)
  {
    dialogRef.disableClose = true;
  }

  ngOnInit()
  {
  }
}
